
/* Collection Sort By function
**********************************************************************/

jQuery(document).ready(function($) {
	
	// Check if element exists
	if ($('#sort-by').length == 0)
		return;
	
	var sort = $('#sort-by');	
	var selected = sort.attr('data-selected');
	
	sort.val(selected);
	
	sort.on('change', function() {
		
		var search = {};
		
		if (location.search != '') {
			search = location.search.substring(1).replace(/&/g, '","').replace(/=/g,'":"');
			search = JSON.parse('{"' + search + '"}', function(key, value) { 
				return key === '' ? value:decodeURIComponent(value) 
			});
		}
		
		search.sort_by = $(this).val();
		location.search = $.param(search);

	});
	
});